module.exports = __webpack_public_path__ + "static/media/twentygoals.25cd0d6f.jpg";